import React from 'react'
import { object, string, bool } from 'prop-types'

class PhoneNumber extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      agentData: this.props.agentData
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      agentData: nextProps.agentData
    })
  }

  getPhoneNumber () {
    const { agents, agentData, productType } = this.props
    if (agents[productType]) return agents[productType]
    if (agentData.DDI) return agentData.DDI
    return agents.switchboardNumber
  }

  isNotFree () {
    if (this.getPhoneNumber().substr(0, 4) !== '0800') {
      return "Please note, calls to this phone number cost 11 pence per minute, plus your phone company's access charge."
    }
  }

  render () {
    const { agentData, trackingName, customerNumber, showCustomerNumber } = this.props
    if (!agentData.agent) return null
    const agent = agentData.agent
    let quoteValue = agent
    let customerNumberSufix = ''
    let label = 'is your reference'
    if (showCustomerNumber) {
      quoteValue = customerNumber
      customerNumberSufix = ',' + customerNumber
      label = 'is your unique customer number'
    }

    return (
      <div>
        <div className='numberArea'>
          <strong className='customerNumber'>
            <a href={'tel:' + this.getPhoneNumber().replace(/ /g, '') + customerNumberSufix} data-track-name={trackingName} className='visible-xs visible-sm'>{ quoteValue }</a>
            <a href={'tel:' + this.getPhoneNumber().replace(/ /g, '')} data-track-name={trackingName} className='hidden-xs hidden-sm'>{ quoteValue }</a>
          </strong>
          {label}, you will be asked to provide this when you call us on:
          <strong>
            <a href={'tel:' + this.getPhoneNumber().replace(/ /g, '') + customerNumberSufix} data-track-name={trackingName} className='visible-xs visible-sm'>{ this.getPhoneNumber() }</a>
            <a href={'tel:' + this.getPhoneNumber().replace(/ /g, '')} data-track-name={trackingName} className='hidden-xs hidden-sm'>{ this.getPhoneNumber() }</a>
          </strong>
          <p>{ this.isNotFree() }</p>
        </div>
      </div>
    )
  }
}

PhoneNumber.propTypes = {
  agents: object,
  agentData: object,
  trackingName: string,
  productType: string,
  customerNumber: string,
  showCustomerNumber: bool
}

PhoneNumber.defaultProps = {
  showCustomerNumber: false
}

export default PhoneNumber



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/contactCentre/phoneNumber.jsx